import React from "react";
import SharedFilesPanel from "../../properties/panels/FilesPanel";

const FilesPanel = ({
  contactInfo,
  updateContactInfo,
  uploadSingle,
  actionSave,
  filesDisplayName,
  setFilesDisplayName,
  filesSelectedType,
  setFilesSelectedType,
  filesSelectedFile,
  setFilesSelectedFile,
  filesStatus,
  setFilesStatus,
  filesProgress,
  setFilesProgress,
  triggerAddFile = 0,
  onOpenSearchTab,
  onClose,
  onCollapse,
  fileFilters,
  fileSettingsType = "contact",
  fileRefCollection = "contacts",
  fileRefSchemaType = "contact",
  fileRefName = "contacts",
  emptySelectionMessage = "Select contact first",
  previewEntityType = "contact",
  entityName = "",
}) => {
  return (
    <SharedFilesPanel
      onClose={onClose}
      onCollapse={onCollapse}
      propertyInfo={contactInfo}
      updatePropertyInfo={updateContactInfo}
      uploadSingle={uploadSingle}
      actionSave={actionSave}
      filesDisplayName={filesDisplayName}
      setFilesDisplayName={setFilesDisplayName}
      filesSelectedType={filesSelectedType}
      setFilesSelectedType={setFilesSelectedType}
      filesSelectedFile={filesSelectedFile}
      setFilesSelectedFile={setFilesSelectedFile}
      filesStatus={filesStatus}
      setFilesStatus={setFilesStatus}
      filesProgress={filesProgress}
      setFilesProgress={setFilesProgress}
      triggerAddFile={triggerAddFile}
      onOpenSearchTab={onOpenSearchTab}
      fileSettingsType={fileSettingsType}
      fileRefCollection={fileRefCollection}
      fileRefSchemaType={fileRefSchemaType}
      fileRefName={fileRefName}
      emptySelectionMessage={emptySelectionMessage}
      previewEntityType={previewEntityType}
      entityName={entityName}
      fileFilters={fileFilters}
    />
  );
};

export default FilesPanel;
